import { render, staticRenderFns } from "./counselorPage.vue?vue&type=template&id=83b1e334&scoped=true"
import script from "./counselorPage.vue?vue&type=script&lang=js"
export * from "./counselorPage.vue?vue&type=script&lang=js"
import style0 from "./counselorPage.vue?vue&type=style&index=0&id=83b1e334&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b1e334",
  null
  
)

export default component.exports